import { Component, inject, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { IntensityGaugeComponent } from '../graphs/intensity-gauge/intensity-gauge.component';
import { EcoScoreService } from 'src/app/shared/services/eco-score.service';
import { FormatCo2eService } from 'src/app/shared/services/format-co2e.service';

@Component({
  selector: 'app-eco-score',
  imports: [
    CommonModule,
    LucideAngularModule,
    TranslocoModule,
    IntensityGaugeComponent,
  ],
  templateUrl: './eco-score.component.html',
})
export class EcoScoreComponent implements OnChanges, OnInit {
  @Input() isOpen: boolean = false;
  @Input() carbonIntensity: number = 0;
  displayedCarbonIntensity: string = '';
  displayedUnit: string = '';
  ecoScoreService = inject(EcoScoreService);
  private formatCo2e = inject(FormatCo2eService);

  convertUnit() {
    this.displayedCarbonIntensity = this.formatCo2e.formatValue(this.carbonIntensity);
    this.displayedUnit = this.formatCo2e.getUnit(this.carbonIntensity);
  }
  ngOnChanges() {
    this.convertUnit();
  }
  ngOnInit() {
    this.convertUnit();
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
